import React from 'react'

import Header from '../../../components/header'
import PlanCard from '../../../components/plan-card'
import BackButton from '../../../components/back-button'

import * as S from './styles'

import IProps from './props'

const Plans = ({ states, handlers }: IProps) => (
  <S.Container>
    <Header title="Planos" />
    <form onSubmit={handlers.handleSubmit}>
      <S.CardsContainer>
        {states.plans.map((plan) => (
          <PlanCard
            {...plan}
            key={plan.id}
            selectedPlan={states.selectedPlan}
            onChange={handlers.handleRadioChange}
            isUserPlan={states.userPlan === plan.id}
          />
        ))}
      </S.CardsContainer>
      <S.ButtonsContainer>
        {states.selectedPlan !== states.userPlan && (
          <S.GoForwardButton type="submit">Prosseguir</S.GoForwardButton>
        )}

        <BackButton />
      </S.ButtonsContainer>
      <S.ButtonCancell onClick={handlers.handleCancelPlan} type="button">
        Cancelar assinatura
      </S.ButtonCancell>
    </form>
  </S.Container>
)

export default Plans
